import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { TableColumnModel } from "@interfaces/models";

export const TableHead = ({
  columns,
  className,
  dataTestid,
}: {
  columns: TableColumnModel[];
  className?: string;
  dataTestid?: string;
}) => (
  <thead data-testid={dataTestid}>
    <tr className={twMerge(clsx("border-b border-b-black-8", className))}>
      {columns.map(({ title, width, alignRight }) => (
        <th
          key={`${title}-${width}`}
          className={clsx(
            "pb-3 pt-3 text-100 font-normal text-black-54 md:pb-4 md:pt-5",
            alignRight ? "pr-6 text-right" : "text-left",
            width,
          )}
        >
          {title}
        </th>
      ))}
    </tr>
  </thead>
);
